<template>
    <div
        :class="dir.class"
        @click="$emit('click-dir', dir.url)"
    >
        <span class="title">{{ dir.title }}</span>
    </div>
</template>

<script>
export default {
  name: "RavDirElt",
  props: {
    dir: {
        type: Object,
        default: function() { return {} }
    }
  }
};
</script>

<style lang="scss">
.dir-elt {
    display: inline-table;
    width: 160px;
    height: 45px;
    vertical-align: top;
    background-color: #fff;
    color: #999;
    border: 1px solid #ddd;
    border-radius: 2px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
    background-image: url("../assets/img/folder_med.png");
    background-repeat: no-repeat;
    background-position: 5px 50%;
    margin: 0 10px 10px 0;
    padding: 5px;
    cursor: pointer;
    transition: all 0.3s;
    -webkit-transition: all 0.3s;

    &.back {
    background-image: url("../assets/img/folder_med_back.png");
    }

    &:hover {
        border: 1px solid #aaa;
        box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
    }

    .title {
        display: table-cell;
        vertical-align: middle;
        padding-left: 55px;
        line-height: 15px;
    }
}
</style>